var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.40001 3.90625C7.40001 3.62665 7.62666 3.4 7.90626 3.4H20.0938C20.3733 3.4 20.6 3.62665 20.6 3.90625V16.0937C20.6 16.3733 20.3733 16.6 20.0938 16.6H18.4V7.90625C18.4 6.63254 17.3675 5.6 16.0938 5.6H7.40001V3.90625ZM5.60001 5.6V3.90625C5.60001 2.63254 6.63255 1.6 7.90626 1.6H20.0938C21.3675 1.6 22.4 2.63254 22.4 3.90625V16.0937C22.4 17.3675 21.3675 18.4 20.0938 18.4H18.4V20.0937C18.4 21.3675 17.3675 22.4 16.0938 22.4H3.90626C2.63255 22.4 1.60001 21.3675 1.60001 20.0937V7.90625C1.60001 6.63254 2.63255 5.6 3.90626 5.6H5.60001ZM3.40001 7.90625C3.40001 7.62665 3.62666 7.4 3.90626 7.4H16.0938C16.3733 7.4 16.6 7.62665 16.6 7.90625V20.0937C16.6 20.3733 16.3733 20.6 16.0938 20.6H3.90626C3.62666 20.6 3.40001 20.3733 3.40001 20.0937V7.90625Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.eafdef185244e3f72cb25851db3d5f2b.svg";
export { ForwardRef as ReactComponent };